// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"constellation_wrapper__qzYfl","body":"constellation_body__82xvA","imageWrapper":"constellation_imageWrapper__ivNKu"};